import { useState } from "react";
import { Shield, HeartPulse, Coins, Car, Bike, Users, Plane, User2, PiggyBank, HandCoins, Baby, Landmark, Building2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import LoanOptions from "./LoanOptions";

export default function DashboardContent() {
  const [activeSlide, setActiveSlide] = useState(0);
  const navigate = useNavigate();

  const sliderContent = [
    {
      title: "Hospitalized for 2 Hours?",
      subtitle: "YOU’RE NOW COVERED!",
      description: "No need to wait 24-hours for claim anymore!",
      button: "View plans",
    },
  ];


  const insuranceCategories = [
    { label: "Personal Loan", icon: Shield, tag: "Explore flexible financing options for your individual needs, from debt consolidation to unexpected expenses.", url: "/personal-loan" },
    { label: "Business Loan", icon: HeartPulse, tag: "Discover tailored solutions to fuel your business growth, manage cash flow, or invest in new opportunities.", url: ""  },
    { label: "Home Loan", icon: Coins, tag: "Find competitive rates and expert guidance to help you purchase your dream home or refinance your existing mortgage.", url: ""  }
  ];

  return (
    <div className="w-full px-6 py-12 bg-white">
      {/* Header */}
      <div className="text-center max-w-2xl mx-auto mb-10">
        <h1 className="text-3xl font-bold text-gray-900">
          Let’s find you the <span className="text-blue-600">best </span> offers
        </h1>
        {/* <div className="flex items-center justify-center gap-6 mt-4 text-sm text-gray-600">
          <span className="flex items-center gap-2 text-purple-600">
            51 insurers offering lowest prices
          </span>
          <span className="flex items-center gap-2 text-orange-500">
            Quick, easy & hassle free
          </span>
        </div> */}
      </div>

      {/* Banner */}
      {/* <div className="max-w-3xl mx-auto mb-12">
        <div className="bg-blue-900 text-white rounded-2xl p-8 relative shadow-lg">
          <h2 className="text-xl font-semibold mb-2">{sliderContent[0].title}</h2>
          <p className="font-bold text-green-400">{sliderContent[0].subtitle}</p>
          <p className="mt-2 text-gray-200">{sliderContent[0].description}</p>
          <button className="mt-4 px-5 py-2 bg-white text-blue-700 rounded-lg font-semibold shadow hover:bg-gray-100 transition">
            {sliderContent[0].button}
          </button>
          <div className="absolute right-6 bottom-6 text-center">
            <div className="w-20 h-20 bg-blue-800 rounded-full flex items-center justify-center">
              <span className="text-lg font-bold">02:00</span>
            </div>
            <p className="text-xs mt-1">HOURS</p>
          </div>
        </div>
      </div> */}

      {/* Categories */}
        <LoanOptions />
    </div>
  );
}
